const carouselImages = {
  home: [
    "/images/kemper/products/kemper_hero_einstein_3.webp",
    "/images/tonex/products/tonex_hero_sfam_1.webp",
    "/images/profiles_hero.webp",
    "/images/kemper/products/kemper_hero_mark2a.jpg",
  ],
  kemper: [
    "/images/kemper/products/kemper_hero_mark2a.jpg",
    "/images/kemper/products/kemper_hero_einstein_3.webp",
    "/images/kemper/products/kemper_hero_sfam.webp",
    "/images/kemper/products/kemper_hero_mark35_2.webp",
  ],
  tonex: [
    "/images/tonex/products/tonex_hero_sfam_3.webp",
    "/images/tonex/products/tonex_hero_sfam_2.webp",
    "/images/tonex/products/tonex_hero_sfam_1.webp",
  ],
  nam: [
    "/images/nam/products/nam_hero_marstate.webp",
    "/images/nam/products/nam_hero_kitty.webp",
  ],
  plugin: [
    "/images/plugins/pwc_nam_skin/hero_nam_skin_window_laptop.jpg",
    "/images/plugins/pwc_nam_skin/pwc_nam_skin_screenshot_amp_cab.webp",
    "/images/plugins/pwc_nam_skin/pwc_nam_skin_screenshot_back.webp",
  ],
};

export default carouselImages;
